<template>
    <div class="gruppen">
        <breadcrumb></breadcrumb>
        <category-content></category-content>
    </div>
</template>

<script>
import breadcrumb from '../components/breadcrumb';
import CategoryContent from '../components/categoryContent';

export default {
    components: {
        CategoryContent,
        breadcrumb,
    },
};
</script>
